import './styles/index.scss';
import { Suspense, useEffect } from 'react';
import { AppRouter } from '@/app/providers/router';

const App = () => {
  useEffect(() => {
    const metaName = 'robots';
    const selector = `meta[name="${metaName}"]`;
    const existingMeta = document.head.querySelector<HTMLMetaElement>(selector);

    if (existingMeta) {
      existingMeta.setAttribute('content', 'noindex,nofollow');
      return;
    }

    const meta = document.createElement('meta');
    meta.name = metaName;
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
  }, []);

  return (
    <Suspense>
      <AppRouter />
    </Suspense>
  );
};

export default App;
